// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/task/v1/audit_search.proto" (package "c1.api.task.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { TaskAuditSearchService } from "./audit_search";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { TaskAuditSearchServiceSearchResponse } from "./audit_search";
import type { TaskAuditSearchServiceSearchRequest } from "./audit_search";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.task.v1.TaskAuditSearchService
 */
export interface ITaskAuditSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: TaskAuditSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<TaskAuditSearchServiceSearchRequest, TaskAuditSearchServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.task.v1.TaskAuditSearchService
 */
export class TaskAuditSearchServiceClient implements ITaskAuditSearchServiceClient, ServiceInfo {
    typeName = TaskAuditSearchService.typeName;
    methods = TaskAuditSearchService.methods;
    options = TaskAuditSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: TaskAuditSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<TaskAuditSearchServiceSearchRequest, TaskAuditSearchServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<TaskAuditSearchServiceSearchRequest, TaskAuditSearchServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
